import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { Cadenas } from "../../Cadenas/Cadenas";
import { catCanales } from "../../Categorias y Estados/catCanales";
import { Clientes } from "../../Clientes/Clientes";
import { Ciudades } from "../../Paises/Ciudades/Ciudades";
import { Localidades } from "../../Paises/Localidades/Localidades";
import { Paises } from "../../Paises/Paises";
import { Provincias } from "../../Paises/Provincias/Provincias";
import { Personal } from "../../Personal/Personal";

const columns = () =>
(
    {
        c_pais_id: new EntityColumn<string>({ name: 'c_pais_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'País' }),
        c_provincia_id: new EntityColumn<string>({ name: 'c_provincia_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Provincia' }),
        c_ciudad_id: new EntityColumn<string>({ name: 'c_ciudad_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Ciudad' }),
        c_localidad_id: new EntityColumn<string>({ name: 'c_localidad_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Localidad' }),
        vc_cadenas: new EntityColumn<string[]>({ name: 'vc_cadenas', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Cadenas', isArray: true }),
        vc_canales: new EntityColumn<string[]>({ name: 'vc_canales', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Canales', isArray: true }),

        vc_supervision: new EntityColumn<string[]>({ name: 'vc_supervision', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Supervisión', isArray: true }),
        vc_visitas: new EntityColumn<string[]>({ name: 'vc_visitas', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Visitas', isArray: true }),
        vc_clientes: new EntityColumn<string[]>({ name: 'vc_clientes', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Clientes', isArray: true }),

        b_sinpersonal: new EntityColumn<boolean>({ name: 'b_sinpersonal', type: 'bit', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Solo sin personal asignado' }),
        b_sinrutascompartidas: new EntityColumn<boolean>({ name: 'b_sinrutascompartidas', type: 'bit', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Solo sin rutas compartidas' }),
        b_sinrutasexclusivas: new EntityColumn<boolean>({ name: 'b_sinrutasexclusivas', type: 'bit', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Solo sin rutas exclusivas' }),
        b_compartidassobreasginadas: new EntityColumn<boolean>({ name: 'b_compartidassobreasginadas', type: 'bit', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Solo rutas compartidas sobreasignadas' }),
        b_exclusivassobreasginadas: new EntityColumn<boolean>({ name: 'b_exclusivassobreasginadas', type: 'bit', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Solo rutas exclusivas sobreasignadas' }),
        b_compartidasnocubiertas: new EntityColumn<boolean>({ name: 'b_compartidasnocubiertas', type: 'bit', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Solo rutas compartidas no cubiertas' }),
        b_exclusivasnocubiertas: new EntityColumn<boolean>({ name: 'b_exclusivasnocubiertas', type: 'bit', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Solo rutas exclusivas no cubiertas' }),
        b_incluirbajas: new EntityColumn<boolean>({ name: 'b_incluirbajas', type: 'bit', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Incluir personal de baja' }),
        ...DefaultColumns()
    }
)

const lookups = () =>
(
    {
        'Cadenas': {
            name: 'Cadenas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Cadenas(client, parentKeys)
        },

        'Paises': {
            name: 'Paises',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Paises(client, parentKeys)
        },

        'Provincias': {
            name: 'Provincias',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Provincias(client, parentKeys)
        },

        'Ciudades': {
            name: 'Ciudades',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Ciudades(client, parentKeys)
        },

        'Localidades': {
            name: 'Localidades',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Localidades(client, parentKeys)
        },

        'Supervision': {
            name: 'Supervision',
            view: 'perl_brwAsignadoATiendas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Personal(client, parentKeys)
        },

        'Visitas': {
            name: 'Visitas',
            view: 'perl_brwEnRutas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Personal(client, parentKeys)
        },

        'Canales': {
            name: 'Canales',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catCanales(client, parentKeys)
        },

        'Clientes': {
            name: 'Clientes',
            viewMapping: { keyIndex: 0, descriptionIndex: 2 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Clientes(client, parentKeys)
        },
    }
)

export class RutasTiendasFiltersDef extends EntityDefinition {

    columns = columns();
    views = {};
    lookups = lookups();

    constructor() {
        super('RutasTiendasFilters');
    }
}